var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33268 0.158203V15.8409L3.02043 10.6662H0.666016V5.3329H3.02043L7.33268 0.158203ZM5.99935 3.84094L3.64493 6.66624H1.99935V9.3329H3.64493L5.99935 12.1582V3.84094Z",
    fill: "currentColor  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3641 3.921L10.8875 4.33392C11.9694 5.1874 12.6658 6.51231 12.6658 7.99948C12.6658 9.48666 11.9694 10.8116 10.8875 11.6651L10.3641 12.078L9.5383 11.0312L10.0617 10.6183C10.8368 10.0067 11.3324 9.06118 11.3324 7.99948C11.3324 6.93779 10.8368 5.99223 10.0617 5.38071L9.5383 4.9678L10.3641 3.921Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42276 5.93373L8.99983 6.26755C9.59589 6.61235 9.99935 7.25845 9.99935 7.99957C9.99935 8.74069 9.59589 9.3868 8.99984 9.7316L8.42276 10.0654L7.75513 8.91128L8.3322 8.57746C8.5332 8.46118 8.66601 8.24549 8.66601 7.99957C8.66601 7.75365 8.5332 7.53796 8.3322 7.42169L7.75513 7.08787L8.42276 5.93373Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMedium);
export default __webpack_public_path__ + "static/media/volume-medium.e4c32326b2e68f65d2fa3ccc3b1492e6.svg";
export { ForwardRef as ReactComponent };